/**
 * @generated SignedSource<<2633320a5d7d62d499e6718a765d3e89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopBar_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountNav_user" | "CartNav_user" | "Notifications_user">;
  readonly " $fragmentType": "TopBar_user";
};
export type TopBar_user$key = {
  readonly " $data"?: TopBar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopBar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_user",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AccountNav_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CartNav_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Notifications_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8b9d906e238b5be75ac5e5f3ac98ae6e";

export default node;
